import React, {useContext, useEffect, useState} from 'react';
import './Selections.scss';
import {Button, Loader, Modal} from '../_common';
import {I18nContext} from '../../contexts/i18nContext';
import {SelectionsContext} from '../../contexts/selectionsContext';
import SelectionForm from './SelectionForm';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmationModal from "../_common/ConfirmationModal";

const Selections = () => {
  const { t } = useContext(I18nContext);
  const {
    pending,
    selections,
    getSelections,
    selectionVersion,
    getSelectionVersion,
    addSelection,
    updateSelection,
    deleteSelection
  } = useContext(SelectionsContext);
  const [selected, setSelected] = useState(null);
  const [showAddSelectionsListModal, setShowAddSelectionsListModal] = useState(false);
  const [showEditSelectionsListModal, setShowEditSelectionsListModal] = useState(false);
  const [showSelectionListDeleteConfirmationModal, setShowSelectionListDeleteConfirmationModal] = useState(false);

  useEffect(() => {
    getSelections();
  }, []);

  const toggleShowAddSelectionsListModal = () => {
    setShowAddSelectionsListModal(!showAddSelectionsListModal);
  };

  const addNewSelectionList = async data => {
    const newSelectionList = await addSelection(data);
    toggleShowAddSelectionsListModal();
    getSelections();
  };

  const toggleShowEditSelectionsListModal = () => {
    setShowEditSelectionsListModal(!showEditSelectionsListModal);
  };

  const handleEditSelectionListClick = selection => {
    getSelectionVersion(selection.id);
    setSelected(selection);
    toggleShowEditSelectionsListModal();
  };

  const handleCloseEditSelectionModal = () => {
    setSelected(null);
    toggleShowEditSelectionsListModal();
    getSelections();
  };

  const editSelectionList = async (data, id, version) => {
    const updatedSelectionList = await updateSelection(data, id, version);
    toggleShowEditSelectionsListModal();
    getSelections();
  };

  const toggleShowConfirmDeleteSelectionListModal = () => {
    setShowSelectionListDeleteConfirmationModal(!showSelectionListDeleteConfirmationModal);
  };

  const handleDeleteSelectionListClick = selection => {
    setSelected(selection);
    toggleShowConfirmDeleteSelectionListModal();
  };

  const removeSelection = async id => {
    const deletedSelection = await deleteSelection(selected.id);
    getSelections();
    setSelected(null);
    toggleShowConfirmDeleteSelectionListModal();
  };

  return (
    <div className='Selections'>
      <div className='header'>
        <div className='headerTitle'></div>
        <div className='headerButtons'>
          <Button type='secondary' label={t('add selection')} action={toggleShowAddSelectionsListModal} />
        </div>
      </div>

      <div className='selectionsList'>
        {pending && (
          <div className='loaderWrapper'><Loader /></div>
        )}

        {!pending && selections.map(selection => (
          <div className='selectionItem' key={selection?.id}>
            <div className='selectionItemContent'>
              <div className='selectionName'>
                {selection?.name}
              </div>
              <div className='selectionOptionsHeader'>{t('options')}:</div>
              <ul className='selectionOptions'>
                {selection?.options.map(option => (
                  <li className={`selectionOption ${option.deleted ? 'selectionOptionDeleted' : ''}`} key={option?.option}>
                    {option?.option}
                  </li>
                ))}
              </ul>
            </div>
            <div className='selectionItemActions'>
              <div className='actionButton' onClick={() => handleEditSelectionListClick(selection)}>
                <EditIcon />
              </div>
              <div className='actionButton' onClick={() => handleDeleteSelectionListClick(selection)}>
                <DeleteIcon />
              </div>
            </div>
          </div>
        ))}
      </div>

      {!!showAddSelectionsListModal && (
        <Modal
          closeModal={toggleShowAddSelectionsListModal}
          title={t('add selection')}
          width='310px'
        >
          <SelectionForm
            primaryButtonAction={addNewSelectionList}
            secondaryButtonAction={toggleShowAddSelectionsListModal}
          />
        </Modal>
      )}

      {!!showEditSelectionsListModal && (
        <Modal
          closeModal={handleCloseEditSelectionModal}
          title={t('edit selection')}
          width='310px'
        >
          <SelectionForm
            primaryButtonAction={editSelectionList}
            secondaryButtonAction={handleCloseEditSelectionModal}
            selection={selected}
            version={selectionVersion}
          />
        </Modal>
      )}

      {!!showSelectionListDeleteConfirmationModal && (
        <ConfirmationModal
          title={t('delete selection')}
          itemName={selected.name}
          closeModal={toggleShowConfirmDeleteSelectionListModal}
          primaryButtonAction={removeSelection}
        />
      )}
    </div>
  )
};

export default Selections;
